export const LOGIN_PAGE_PATHNAME = "/login";
export const LOGIN_REQUEST_PATHNAME = "/login";
export const LOGOUT_REQUEST_PATHNAME = "/auth/jwt-logout";
